let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lFYYm")).then(() => parcelRequire('1hNQG'));